import formComponent from '@/util/proto/formComponent'

const result = [
  {value:1 , label:'通过'},
  {value:4 , label:'拒绝'},
]

export default {
  extends: formComponent ,
  props:['courierId','beforeSave'],
  data() {
    return {
      loading:false,
      formData:{
        state: {
          rules:[
            { required: true, type:'number',message: '请选择审核结果', trigger: 'blur,change' },
          ]
        },
        templateId: {
          rules:[
            { required: true, type:'number',message: '请选择试题模板', trigger: 'blur,change' },
          ]
        },
        remark: {
          rules:[
            { required: true, message: '请填写拒绝理由', trigger: 'blur,change' },
          ]
        },
      },
      state:{
        state:null,
        templateId:null,
        remark:null
      },
      //examTpl:[]
    }
  },
  computed:{
    examTpl(){
      return this.$request.courierExamTpl(this.courierId).then( resp => {
        return Promise.resolve( (resp.data || []).sort((a,b) => a.createDatetime > b.createDatetime ? -1 : 1).map(i=>({value:i.id , label:i.name})) )
      })
    }
  },
  methods:{
    saveProcsss(data){
      const params = { ...data , id:this.courierId}

      this.loading = true
      this.$request.courierExamReview(params).then(resp => {
        this.loading = false
        
        if(resp.code){
          this.$Message.error(resp.msg)
        }else{
          this.$Message.success('审核完成')
          this.$emit('ok')
        }
      })  
    },
    save(data){
      if( this.beforeSave ){
        this.beforeSave().then(resp => {
          if(resp) this.saveProcsss(data)
        })
      }else{
        this.saveProcsss(data)
      }
      
    },
  },
  render(){
    const { loading , formData } = this
    let state = this.form ? this.form.getFieldValue('state') : null
    let extra
    if( state == 1 ){
      extra = <sl-form-item  label="试题模板">
              <sl-select auto-fill={true} dict={this.examTpl} v-decorator={formData.templateId} />
            </sl-form-item>
    }else if(state == 4){
      extra = <sl-form-item  label="审批理由">
              <Input type="textarea" placeholder="审批理由" autosize={{ minRows: 2, maxRows: 6 }} v-decorator={formData.remark} />
            </sl-form-item>
    }
    return (
      <div>
        <div class="modal-body">
          <sl-form label-width={110}>
            <sl-form-item  label="审核结果">
              <sl-select dict={result} type="radio" v-decorator={formData.state} />
            </sl-form-item>
            {extra}
          </sl-form>
        </div>
        <div class="modal-footer">
          <Button loading={loading} on-click={this.$handleSubmit} type="primary">确定</Button>
        </div>
      </div>
    )
  }
}